import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiDms} from "./UiDms";
import {UiFlashMessage} from "../UiFlashMessage";
import {ErrorMarker} from "../ErrorMarker";
import {BaseEditor} from "../BaseEditor";

export class UiBuSubjectEditor extends BaseEditor
{
	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`<div>
			<fieldset><legend>Základní údaje</legend>
				<div class="form-group row">
					<label mu-for="name" class="col-sm-3 control-label">Název</label>
					<div class="col-sm-9">
						<input type="text" mu-id="name" mu-bind="name" class="form-control" />
					</div>
				</div>
				<div class="form-group row">
					<label mu-for="ic" class="col-sm-3 control-label">IČ</label>
					<div class="col-sm-9">
						<div class="input-group">
							<input type="text" mu-id="ic" mu-bind="ic" class="form-control" />
							<span class="input-group-btn">
								<button class="btn btn-default" type="button" mu-id="bLoadFromAres">Načíst</button>
							</span>
						</div>
						<div mu-for="error:ic"></div>
					</div>
				</div>
				<div class="form-group row">
					<label mu-for="dic" class="col-sm-3 control-label">DIČ</label>
					<div class="col-sm-9">
						<input type="text" mu-id="dic" mu-bind="dic" class="form-control" />
					</div>
				</div>
				<div class="form-group row" mu-id="block_internalCode">
					<label mu-for="internalCode" class="col-sm-3 control-label">Kód interního subjektu</label>
					<div class="col-sm-9">
						<input type="text" mu-id="internalCode" mu-bind="internalCode" class="form-control" />
					</div>
				</div>
				<div class="col-sm-9 col-sm-offset-3" mu-for="error:internalCode"></div>
				<div class="form-group row" mu-id="block_emails">
					<label mu-for="emails" class="col-sm-3 control-label">Emaily subjektu</label>
					<div class="col-sm-9">
						<input type="text" mu-id="emails" mu-bind="emails" class="form-control" />
					</div>
				</div>
			</fieldset>
			<fieldset><legend>Adresa</legend>
				<div mu-widget="." mu-bind="address" class="address-form">
					<div class="form-group row">
						<label mu-for="street" class="col-sm-3 control-label">Ulice</label>
						<div class="col-sm-9">
							<div class="address-form__street-block">
								<input type="text" mu-bind="street" class="address-form__street-block__street form-control" />
								<label mu-for="numD">ČP</label>
								<input type="text" size="5" mu-bind="numD" class="address-form__street-block__numd form-control" />
								<label mu-for="numO">ČO</label>
								<input type="text" size="3" mu-bind="numO" class="address-form__street-block__numo form-control" />
							</div>
							<div mu-for="error:street"></div>
							<div mu-for="error:numD"></div>
							<div mu-for="error:numO"></div>
						</div>
					</div>
					<div class="form-group row">
						<label mu-for="city" class="col-sm-3 control-label">Město</label>
						<div class="col-sm-9">
							<input type="text" mu-bind="city" class="form-control" />
						</div>
					</div>
					<div class="form-group row">
						<label mu-for="cityPart" class="col-sm-3 control-label">Část obce</label>
						<div class="col-sm-9">
							<input type="text" mu-bind="cityPart" class="form-control" />
						</div>
					</div>
					<div class="form-group row">
						<label mu-for="cityCityPart" class="col-sm-3 control-label">Městská část</label>
						<div class="col-sm-9">
							<input type="text" mu-bind="cityCityPart" class="form-control" />
						</div>
					</div>
					<div class="form-group row">
						<label mu-for="zip" class="col-sm-3 control-label">PSČ</label>
						<div class="col-sm-9">
							<input type="text" mu-bind="zip" class="form-control" />
						</div>
					</div>
				</div>
			</fieldset>
			<fieldset mu-widget="." mu-bind="headerInfo"><legend>Hlavička smlouvy</legend>
				<div class="form-group row">
					<label mu-for="representativeFirstName" class="col-sm-3 control-label">Zastupuje</label>
					<div class="col-sm-9">
						<input type="text" mu-bind="representativeFirst" class="form-control" />
					</div>
				</div>
				<!-- <div class="form-group row">
					<label mu-for="representativeFirstName" class="col-sm-3 control-label">Zastupuje - jméno</label>
					<div class="col-sm-9">
						<input type="text" mu-bind="representativeFirstName" class="form-control" />
					</div>
				</div>
				<div class="form-group row">
					<label mu-for="representativeLastName" class="col-sm-3 control-label">Zastupuje - příjmení</label>
					<div class="col-sm-9">
						<input type="text" mu-bind="representativeLastName" class="form-control" />
					</div>
				</div> -->
				<div class="form-group row">
					<label mu-for="courtName" class="col-sm-3 control-label">Zapsáno u soudu</label>
					<div class="col-sm-9">
						<input type="text" mu-bind="courtName" class="form-control" />
					</div>
				</div>
				<div class="form-group row">
					<label mu-for="courtTract" class="col-sm-3 control-label">Oddíl / vložka</label>
					<div class="col-sm-9">
						<input type="text" mu-bind="courtTract" class="form-control" />
					</div>
				</div>
			</fieldset>
		</div>
		<div class="buttons">
			<span class="btn btn-primary" mu-id="bSave">Uložit</span>
		</div>`);
	}

	afterIndex() {
		super.afterIndex();
		this.muVisible(UiDms.instance?.isAdmin ?? false, "block_internalCode");
	}
	/* emails_keyup(ev: Event) {
		ev.stopPropagation();
	} */

	public async bLoadFromAres_click() {
		const res = await UiDms.instance.cl.loadFromAres(this.ui.ic.value);
		if (res.status == "ok") this.muBindData(res);
		else UiFlashMessage.instance.add(({
			unknownIc: "Neznámé IČ",
			failed: "Ares je nedostupný",
		}[res.status as string] || ""))
	}

	public async bSave_click()
	{
		const data = this.muFetchData();
		const res = await UiDms.instance.cl.saveBuSubject(this.id, data);
		if (res.status === "ok") {
			UiFlashMessage.instance.add("Subjekt uložen");
			this.onSaved(res.entity);
		} else {
			UiFlashMessage.instance.add("Opravte chyby ve formuláři");
		}
		this.errorMarker.markErrors(res.errorList || []);
	}

	async loadItem(id: number) {
		this.id = id;
		this.container.classList.add('loading-data');
		const data = await UiDms.instance.cl.getBuSubject(id);
		this.muBindData(data);
		this.container.classList.remove('loading-data');
	}

	protected showErrors(errors : Record<string, string[]>) {
		const allErrorLabels = Array.from(this.container.querySelectorAll('[mu-for^="error:"]'));
		for(const el of allErrorLabels)
			el.innerHTML = "";
		for(const place in errors) {
			// @ts-ignore
			const cont = this.ui[place]['errorLabel'];

			for(const message of errors[place]) {
				const elMessage = document.createElement("div");
				elMessage.innerText = message;
				cont.appendChild(elMessage);
			}
		}
	}

	ic_keypress(ev: KeyboardEvent) {
		if (ev.key === "Enter") {
			ev.preventDefault();
			ev.cancelBubble = true;
			this.ui.bLoadFromAres.click();
		}
	}

}